import React from "react";
import { type TestimonialData } from "../../utils/mockProjects";
import stringToParagraphs from "../../utils/splitPara";

interface TestimonialsProps {
  testimonials: TestimonialData;
}
export const Testimonials: React.FC<TestimonialsProps> = ({ testimonials }) => {
  return (
    <div className="w-full h-fit flex md:flex-row flex-col justify-between md:gap-8 gap-16 my-4 lg:pb-24  text-primary">
      <div className="w-full h-full lg:border-l lg:px-8 flex flex-col justify-center items-start gap-8">
        <p className="lg:text-2xl md:text-xl text-lg font-gilroy-bold">
          What our client said:
        </p>
        
        <p className="lg:text-[32px] md:text-2xl text-lg lg:px-0 px-5 lg:border-0 border-l font-gilroy-light">
          {testimonials?.text}
        </p>
      </div>

      <div className="w-full lg:flex hidden md:justify-center justify-end items-center">
        <div>
          <p className="lg:text-2xl md:text-xl text-lg font-gilroy-regular">
            {testimonials?.name}
          </p>
          <div className="lg:text-2xl md:text-xl text-lg font-gilroy-regular-italic">
            {stringToParagraphs(testimonials?.designation)}
          </div>
        </div>
      </div>
    </div>
  );
};
